var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DataTable',{attrs:{"title":"KeyWords","fields":_vm.fields,"response":_vm.getKeyWords,"is_createable":false,"show_delete":false,"show_header_filter":false},on:{"edit_click":_vm.editClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }